export default "__VITE_ASSET__BvQkDBtN__"